import { useQuery } from 'react-query';
import { ErrorMessageAPI } from 'api/errorMessage';
import { ERROR_MESSAGES } from 'helpers/constants';

export default function useErrorMessages() {
  return useQuery(ERROR_MESSAGES, ErrorMessageAPI.getAll);
}
